import { Head, useForm, Link } from '@inertiajs/react'
import { FormEvent } from 'react'

interface ImportProps {
  workspace: {
    slug: string
    name: string
  }
}

export default function Import({ workspace }: ImportProps) {
  const { data, setData, post, processing, errors } = useForm<{ file: File | null }>({
    file: null,
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!data.file) return

    const formData = new FormData()
    formData.append('file', data.file)

    post(`/${workspace.slug}/import`, {
      forceFormData: true,
    })
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Head title={`Import - ${workspace.name}`} />

      <nav className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Link href={`/${workspace.slug}`} className="text-xl font-bold text-gray-900">
              {workspace.name}
            </Link>
          </div>
        </div>
      </nav>

      <main className="mx-auto max-w-2xl px-4 py-12 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-gray-900">Import ZIP</h2>
        <p className="mt-2 text-sm text-gray-600">
          Upload an Obsidian-compatible ZIP file to import pages into this workspace.
          Markdown files (.md) will be imported as pages, and folder structure will be preserved.
        </p>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="file" className="block text-sm font-medium text-gray-700">
              ZIP File
            </label>
            <input
              id="file"
              name="file"
              type="file"
              accept=".zip"
              className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:rounded-md file:border-0 file:bg-indigo-50 file:px-4 file:py-2 file:text-sm file:font-medium file:text-indigo-700 hover:file:bg-indigo-100"
              onChange={(e) => setData('file', e.target.files?.[0] || null)}
            />
            {errors.file && <p className="mt-1 text-sm text-red-600">{errors.file}</p>}
          </div>

          <div className="flex items-center gap-4">
            <button
              type="submit"
              disabled={processing || !data.file}
              className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50"
            >
              {processing ? 'Importing...' : 'Import'}
            </button>
            <Link
              href={`/${workspace.slug}`}
              className="text-sm font-medium text-gray-600 hover:text-gray-900"
            >
              Cancel
            </Link>
          </div>
        </form>
      </main>
    </div>
  )
}
